<div class="flex gap-x-8 items-center py-3 justify-between">
  <a routerLink="/" class="flex items-center justify-center">
    <img src="./assets/images/logo.svg" loading="lazy"/>
  </a>
  <franbase-user-dropdown></franbase-user-dropdown>
</div>
